import 'antd/dist/antd.css';
import './style/create-review.css';

import Rate  from 'antd/lib/rate';
import { useState } from 'react';
import { connect } from 'react-redux';
import { createCategoryReview } from '../../../actions'
import { useContext } from 'react';
import { CategoryContext } from './context'
const CreateReview = ({ parent, createCategoryReview, isReply }) => {
    const category = useContext(CategoryContext)
    const [star, setStar] = useState(5);
    const [review, setReview] = useState()
    const desc = ['terrible', 'bad', 'normal', 'good', 'wonderful']
    const onReviewChange = (e) => {
        setReview(e.target.value)
        
    }
    console.log(category)
    const handleRatingChange = value => {
        setStar(value)
    }
    const handleForm = () => {
        let formData = {
            star: star,
            review: review,
            parent: parent,
        }
        if (parent){
            createCategoryReview(formData, category, true)
        }
        else{
            createCategoryReview(formData, category)
        }
        
        setReview("")
    }
    return (
        <form className="ui reply form">
            <div className="field">
                <textarea value={review} onChange={onReviewChange}></textarea>
            </div>
            {!isReply ? <span>
                <Rate tooltips={desc} onChange={handleRatingChange} value={star}/>
                {star ? <span className="ant-rate-text">{desc[star - 1]}</span> : ""}
            </span> : ""}
            <div className="ui positive right labeled submit icon button" onClick={handleForm}>
            <i className="icon edit"></i> {isReply ? "Reply" : "Add Review"}
            </div>
        </form>
    )
}

export default connect(null, { createCategoryReview })(CreateReview)